import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { getSubscriptionStats } from "../../slices/thunks";
import { createSelector } from "reselect";

import ReactApexChart from "react-apexcharts";
import { getDashboardFilterParams } from "./dateFilterUtils";
import { toChartLabel, toChartNumber } from "./dashboardChartUtils";

const SubscriptionStats = ({ dateFilter = null }) => {
  const dispatch = useDispatch();
  const isGlobalDateFilter = Boolean(dateFilter);

  const selectDashboardData = createSelector(
    (state) => state.Dashboard,
    (subscriptionStats) => subscriptionStats
  );
  // Inside your component
  const { subscriptionStats } =  useSelector(selectDashboardData);

  const [state, setState] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: "donut",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 270,
        },
      },
      dataLabels: {
        enabled: true,
        dropShadow: {
          blur: 3,
          opacity: 1,
        },
      },
      fill: {
        type: "gradient",
      },
      legend: {
        formatter: function (val, opts) {
          return val + " - " + opts.w.globals.series[opts.seriesIndex];
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  });
  useEffect(() => {    
    if (subscriptionStats) {
      const byFrequencyData = subscriptionStats.subscriptions_by_frequency ?? {};
      const chartData = Array.isArray(byFrequencyData.datasets?.data)
        ? byFrequencyData.datasets.data
        : [];
      const labels = Array.isArray(byFrequencyData.labels)
        ? byFrequencyData.labels
        : [];

      setState((prevState) => ({
        ...prevState,
        series: chartData.map((value) => toChartNumber(value)),
        options: {
          ...prevState.options,
          labels: labels.map((label) => toChartLabel(label)),
        },
      }));
    }
  }, [subscriptionStats]);

  useEffect(() => {
    if (isGlobalDateFilter) {
      dispatch(getSubscriptionStats(getDashboardFilterParams(dateFilter)));
      return;
    }

    dispatch(getSubscriptionStats());
  }, [
    dateFilter,
    dateFilter?.customDateFrom,
    dateFilter?.customDateTo,
    dateFilter?.period,
    dispatch,
    isGlobalDateFilter,
  ]);

  return (
    <React.Fragment>
      <Card>
        <CardHeader className="border-0 align-items-center d-flex">
          <h4 className="card-title mb-0 flex-grow-1">Subscriptions Stats</h4>
          {/*}
          <div className="d-flex gap-1">
            <button
              type="button"
              className="btn btn-soft-secondary btn-sm shadow-none"
              onClick={() => {
                onChangeChartPeriod("all");
              }}
            >
              ALL
            </button>
            <button
              type="button"
              className="btn btn-soft-secondary btn-sm shadow-none"
              onClick={() => {
                onChangeChartPeriod("month");
              }}
            >
              1M
            </button>
            <button
              type="button"
              className="btn btn-soft-secondary btn-sm shadow-none"
              onClick={() => {
                onChangeChartPeriod("halfyear");
              }}
            >
              6M
            </button>
            <button
              type="button"
              className="btn btn-soft-primary btn-sm shadow-none"
              onClick={() => {
                onChangeChartPeriod("year");
              }}
            >
              1Y
            </button>
          </div>
          */}
        </CardHeader>
        {/*}
        <CardHeader className="p-0 border-0 bg-light-subtle">
          <Row className="g-0 text-center">
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1">
                  <CountUp start={0} end={7585} duration={3} separator="," />
                </h5>
                <p className="text-muted mb-0">Orders</p>
              </div>
            </Col>
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1">
                  <CountUp
                    suffix="k"
                    prefix="$"
                    start={0}
                    decimals={2}
                    end={22.89}
                    duration={3}
                  />
                </h5>
                <p className="text-muted mb-0">Earnings</p>
              </div>
            </Col>
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0">
                <h5 className="mb-1">
                  <CountUp start={0} end={367} duration={3} />
                </h5>
                <p className="text-muted mb-0">Refunds</p>
              </div>
            </Col>
            <Col xs={6} sm={3}>
              <div className="p-3 border border-dashed border-start-0 border-end-0">
                <h5 className="mb-1 text-success">
                  <CountUp
                    start={0}
                    end={18.92}
                    decimals={2}
                    duration={3}
                    suffix="%"
                  />
                </h5>
                <p className="text-muted mb-0">Conversation Ratio</p>
              </div>
            </Col>
          </Row>
        </CardHeader>
*/}
        <CardBody className="p-0 pb-2">
          <div className="w-100">
            <div dir="ltr">
              {subscriptionStats ? (
                <ReactApexChart
                  options={state.options}
                  series={state.series}
                  type="donut"
                  height={350}
                />
              ) : (
                <div className="text-center p-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default SubscriptionStats;
